<div class="ui-g-12">
    <p-fieldset [style]="{'border':'1px solid #000000'}">
        <p-header><b>Login Credentials</b></p-header>
        <div class="ui-g">
            <div class="ui-lg-6 ui-g-12">

                <form #emailEditForm="ngForm" autocomplete="off" (ngSubmit)="submitEditEmail()" accept-charset="UTF-8">
                    <ng-container *ngIf="!this.editData.emailData.isEdit; else editEmailView">
                        <label class="ui-g-12" for="user_id">
                            {{this.editData.emailData.data.getLabel()}}
                        </label>
                        <p>{{this.displayEmailPhone(this.editData.emailData.value)}}</p>
                        <p class="alert alert-danger" *ngIf="!this.editData.emailData.has_verified">
                            Email is not verified.
                        </p>
                        <button pButton type="button" label="Edit" style="margin-bottom:10px;margin-right:5px;"
                            class="ui-button-info ui-button-rounded" (click)="editEmail()" [disabled]="isPosting()">
                        </button>
                    </ng-container>
                    <ng-template #editEmailView>
                        <ng-container *ngIf="this.editData.emailData.tabViewData.selected_tab==0">
                            <userid-input class="col-12" [userid_data]="this.editData.emailData.data"
                                [isPrimeNg]="true">
                            </userid-input>
                            <div class="ui-g-12">
                                <button pButton type="submit" label="Send OTP"
                                    style="margin-bottom:10px;margin-right:5px;"
                                    class="ui-button-success ui-button-rounded"
                                    [disabled]="!emailEditForm.valid || isPosting() || !this.editData.emailData.data.continueButtonCondition()">
                                </button>
                                <button pButton type="button" label="Cancel" style="margin-right:10px;"
                                    class="ui-button-warning ui-button-rounded" (click)="cancelEditEmail()"
                                    [disabled]="isPosting()">
                                </button>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="this.editData.emailData.tabViewData.selected_tab==1">
                            <div class="ui-g">
                                <div class="form-heading-section mt-4 ui-g-12">
                                    <p class="form-sub-heading">
                                        We have sent an OTP on
                                    </p>
                                    <h2>{{this.editData.emailData.data.getCompleteUserIdValue()}}</h2>

                                </div>
                                <div class="form-div ui-g-12">
                                    <form #otpEmailForm="ngForm" (ngSubmit)="otpVerifySubmit()" accept-charset="UTF-8"
                                        id="register_form">
                                        <div class="form-group ui-g">
                                            <otp-input class="ui-g-12" [isPrimeNg]="true"
                                                [otp_data]="this.editData.emailData.otp_data"
                                                (otp_resend)="otp_resend()">
                                            </otp-input>
                                        </div>
                                        <div class="form-group ui-g">
                                            <button pButton type="submit" label="Verify" style="margin-left:10%;"
                                                class="ui-button-success ui-button-rounded"
                                                [disabled]="isPosting() || !otpEmailForm.valid">
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </ng-container>
                    </ng-template>
                    <div class="ui-g-12">
                        <app-error-messages [api_result]="this.editData.emailData.edit_api_result">
                        </app-error-messages>
                        <app-error-messages [api_result]="this.editData.emailData.otp_data.otp_api_result">
                        </app-error-messages>
                    </div>
                </form>
            </div>
            <div class="ui-lg-6 ui-g-12">
                <form #phoneNoEditForm="ngForm" autocomplete="off" (ngSubmit)="submitEditMobile()"
                    accept-charset="UTF-8">
                    <ng-container *ngIf="!this.editData.mobileData.isEdit; else editMobileView">
                        <label class="ui-g-12" for="user_id">
                            {{this.editData.mobileData.data.getLabel()}}
                        </label>
                        <p>{{this.displayEmailPhone(this.editData.mobileData.value)}}</p>
                        <p class="alert alert-danger" *ngIf="!this.editData.mobileData.has_verified">
                            Mobile Number is not verified.
                        </p>
                        <button pButton type="button" label="Edit" style="margin-bottom:10px;margin-right:5px;"
                            class="ui-button-info ui-button-rounded" (click)="this.editMobile()"
                            [disabled]="isPosting()">
                        </button>
                    </ng-container>
                    <ng-template #editMobileView>
                        <ng-container *ngIf="this.editData.mobileData.tabViewData.selected_tab==0">
                            <userid-input class=" col-12" [userid_data]="this.editData.mobileData.data"
                                [isPrimeNg]="true">
                            </userid-input>
                            <div class="ui-g-12">
                                <button pButton type="submit" label="Send OTP" style="margin-right:10px;"
                                    class="ui-button-success ui-button-rounded"
                                    [disabled]="!phoneNoEditForm.valid || isPosting() || !this.editData.mobileData.data.continueButtonCondition()">
                                </button>
                                <button pButton type="button" label="Cancel" style="margin-right:10px;"
                                    class="ui-button-warning ui-button-rounded" (click)="cancelEditMobile()"
                                    [disabled]="isPosting()">
                                </button>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="this.editData.mobileData.tabViewData.selected_tab==1">
                            <div class="ui-g">
                                <div class="form-heading-section mt-4 ui-g-12">
                                    <p class="form-sub-heading">
                                        We have sent an OTP on
                                    </p>
                                    <h2>{{this.editData.mobileData.data.contact_number}}</h2>
                                </div>
                                <div class="form-div ui-g-12">
                                    <form #otpMobileForm="ngForm" (ngSubmit)="otpVerifySubmit()" accept-charset="UTF-8"
                                        id="register_form">
                                        <div class="form-group ui-g">
                                            <otp-input class="ui-g-12" [isPrimeNg]="true"
                                                [otp_data]="this.editData.mobileData.otp_data"
                                                (otp_resend)="otp_resend()">
                                            </otp-input>
                                        </div>

                                        <div class="form-group ui-g">
                                            <button pButton type="submit" label="Verify" style="margin-left:10%;"
                                                class="ui-button-success ui-button-rounded"
                                                [disabled]="isPosting() || !otpMobileForm.valid">
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </ng-container>
                    </ng-template>

                    <div class="ui-g-12">
                        <app-error-messages [api_result]="this.editData.mobileData.edit_api_result">
                        </app-error-messages>
                        <app-error-messages [api_result]="this.editData.mobileData.otp_data.otp_api_result">
                        </app-error-messages>
                    </div>
                </form>
            </div>
            <div class="ui-g-12 text-center">
                <app-loading *ngIf="isPosting()" type="SMALL_LOADER"></app-loading>
            </div>
            <div class="ui-g-12">
                <app-error-messages [api_result]="this.editData.mobile_email_fetch_api_result"></app-error-messages>
            </div>
        </div>
    </p-fieldset>
</div>